app.service('loanCalculatorService', ["BrowserStorageService", function(BrowserStorageService) {
	var propertyPrice = 0,
		ownSavings = propertyPrice * 0.10,
		loanTime = 25,
		interestRate = 1.2,
		monthlyDue = 0,
		wholeEstimate = 0,
		loanBatches = 0,
		multiplier = 0,
		loanTimeOptions = [
			{value: 10, default: false},
			{value: 15, default: false},
			{value: 20, default: false},
			{value: 25, default: true}
		];

	return {
		getMonthlyDue: getMonthlyDue,
		getLoanTime: getLoanTime,
		getInterestRate: getInterestRate,
		getLoanBatches: getLoanBatches,
		getWholeEstimate: getWholeEstimate,
		setDetails: setDetails,
		getLoanTimeOptions: getLoanTimeOptions,
		getSavedDetails: getSavedDetails,
		saveDetails: saveDetails
	};

	function getInterestRate() {
		return interestRate;
	}

	function getLoanTime() {
		return loanTime;
	}

	function getLoanBatches() {
		return loanBatches;
	}

	function getWholeEstimate() {
		return wholeEstimate;
	}

	function getMonthlyDue() {
		return monthlyDue;
	}

	function getLoanTimeOptions() {
		return loanTimeOptions;
	}

	function setDetails(price, time, interest, savings, propertyId) {
		propertyPrice = (!price) ? 0 : price;
		loanTime = parseInt(time);
		interestRate = (!interest) ? interestRate : interest;
		ownSavings = (!savings) ? 0 : savings;

		propertyPrice = parseFloat(propertyPrice);
		ownSavings = parseFloat(ownSavings);
		interestRate = parseFloat(interestRate);

		// Do not change order or calculations will break!
		calculateLoanBatches();
		calculateMultiplier();
		calculateMonthlyDue();
		calculateWholeEstimate();
	}

	function saveDetails(price, time, interest, savings, propertyId) {
		price = parseFloat(price);
		savings = parseFloat(savings);
		interest = parseFloat(interest);

		BrowserStorageService.LocalStorage.SetItem('loadCalculationFor_' + propertyId, {price: parseFloat(price), time: parseInt(time), interest: interest, savings: parseFloat(savings)});
	}

	function getSavedDetails(propertyId) {
		if (!propertyId) {
			return false;
		}

		var savedData = BrowserStorageService.LocalStorage.GetItem('loadCalculationFor_' + propertyId) || false;

		if (savedData) {
			savedData.interest = parseFloat(savedData.interest.toString().replace(/[,]/, '.'));
		}

		return savedData;
	}

	function calculateWholeEstimate() {
		wholeEstimate = monthlyDue * loanBatches;
	}

	function calculateLoanBatches() {
		loanBatches = loanTime * 12;
	}

	function calculateMonthlyDue() {
		monthlyDue = Math.round(multiplier * (propertyPrice - ownSavings));
	}

	function calculateMultiplier() {
		var A = interestRate / 1200;
		var B = Math.pow((1 + A), loanBatches);
		var C = Math.pow((1 + A), loanBatches) - 1;
		multiplier = (A * B) / C;
	}
}]);